import { render, staticRenderFns } from "./owner_family.vue?vue&type=template&id=7ebc33f0&scoped=true&"
import script from "./owner_family.vue?vue&type=script&lang=js&"
export * from "./owner_family.vue?vue&type=script&lang=js&"
import style0 from "./owner_family.vue?vue&type=style&index=0&id=7ebc33f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ebc33f0",
  null
  
)

component.options.__file = "owner_family.vue"
export default component.exports